import EditCategoryContainer from "@containers/dashboard/categories/edit";
import { CategoryDefaultValue } from "@containers/dashboard/categories/edit/settings";
import DashboardLayout from "@layouts/dashboard";
import RoutesInstance from "@routes/instances";
import { useQuery } from "@tanstack/react-query";
import Common from "@utilities/common";
import { useEffect } from "react";
import {
    useLocation,
    useNavigate,
    useParams,
    useSearchParams,
} from "react-router-dom";

const EditCategory = () => {
    const params = useParams();

    const [URLSearchParams] = useSearchParams();

    const { pathname } = useLocation();

    const Navigate = useNavigate();

    const { data, isLoading, refetch } = useQuery(
        ["getCategory"],
        () =>
            Common.api.categories
                .GetSingle({
                    id: params.id || "",
                })
                .then((res) => res.data),
        {
            enabled: true,
            retry: false,
            onError: () => {
                Navigate(RoutesInstance.categories);
            },
            onSuccess: () => {
                URLSearchParams.set("refetch", "");

                Navigate(
                    {
                        pathname,
                        search: "?" + URLSearchParams.toString(),
                    },
                    {
                        replace: true,
                    },
                );
            },
        },
    );

    useEffect(() => {
        if (URLSearchParams.get("refetch") === "true") {
            refetch();
        }
    }, [URLSearchParams]);

    return (
        <DashboardLayout title="ویرایش دسته بندی">
            <EditCategoryContainer
                data={data?.result || CategoryDefaultValue}
                loading={isLoading}
            />
        </DashboardLayout>
    );
};

export default EditCategory;
